import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ['item', 'column'];

  connect() {
    const that = this
    this.columnTargets.forEach((column) => {
      Sortable.create(column, {
        group: column.dataset.type,
        animation: 150,
        ghostClass: 'bg-orange-100',
        onEnd: that.end.bind(this)
      })
    });
  }

  async end(event) {
    const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
    let data = new FormData();

    if (event.from !== event.to) {
      let state = event.item.parentNode.dataset.state;
      let parent = event.item.parentNode.dataset.swimlane;
      data.append(`${event.item.dataset.type}[state]`, state);
      if (parent) {
        data.append(`parent_readable_id`, parent);
      }
      data.append(`from_kanban`, true);
    } else {
      const newPosition = event.newIndex + 1;
      data.append(`${event.item.dataset.type}[entry_attributes][id]`, event.item.dataset.id);
      data.append(`${event.item.dataset.type}[entry_attributes][priority]`, newPosition);
    }

    try {
      const response = await fetch(event.item.dataset.url, {
        method: 'PATCH',
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken
        },
        body: data
      });

      if (response.ok) {
        const streamMessage = await response.text();
        Turbo.renderStreamMessage(streamMessage);
      } else {
        event.from.insertBefore(event.item, event.from.children[event.oldIndex]);
      }
    } catch (error) {
      event.from.insertBefore(event.item, event.from.children[event.oldIndex]);
    }
  }
}
